import React from "react";
import { TextBox } from "@hg/dialog-sdk";
import styles from "./index.module.scss";

export const TextBoxContent: React.FC = () => {
    return (
        <div className={styles.contentWrapper}>
            <TextBox.Content
                renderSegment={(segment, index) => {
                    if (segment.effect?.type) {
                        return (
                            <span
                                key={index}
                                className={`dialog-text-effect dialog-text-${segment.effect.type}`}
                                data-effect={segment.effect.type}
                            >
                                {segment.text}
                            </span>
                        );
                    }
                    return <span key={index}>{segment.text}</span>;
                }}
            />
            <span className={styles.cursor}></span>
        </div>
    );
};
